var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var LocalStorage = /** @class */ (function () {
    function LocalStorage() {
        this.check();
    }
    LocalStorage.prototype.check = function () {
        var check_namespace = 'abtesting_check';
        try {
            localStorage.setItem(check_namespace, 'check');
            localStorage.removeItem(check_namespace);
        }
        catch (_a) {
            throw new Error("Local Storage not available");
        }
    };
    LocalStorage.prototype._get = function () {
        return JSON.parse(localStorage.getItem(LocalStorage.namespace) || "{}");
    };
    LocalStorage.prototype.set = function (experiment, scope, value) {
        var _a, _b;
        var all = this._get();
        var oldExperiment = all[experiment] || {};
        var updatedExperiment = __assign(__assign({}, oldExperiment), (_a = {}, _a[scope] = value, _a));
        var merged = __assign(__assign({}, all), (_b = {}, _b[experiment] = updatedExperiment, _b));
        localStorage.setItem(LocalStorage.namespace, JSON.stringify(merged));
    };
    LocalStorage.prototype.get = function (experiment, scope) {
        var storage = this._get();
        if (Object.keys(storage).includes(experiment) && Object.keys(storage[experiment]).includes(scope))
            return storage[experiment][scope];
    };
    LocalStorage.namespace = 'abtesting';
    return LocalStorage;
}());
export default LocalStorage;
